module.exports = __webpack_public_path__ + "img/icon-02.d37f2313.svg";